<!--
 * @Description: 日程
 * @Author: 山淑兰
 * @Date: 2020-04-30 13:07:46
 * @LastEditTime: 2020-07-16 22:34:28
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="schedule" v-loading="isLoading">
		<div class="schedule_container">
			<div class="position" v-if="navShow">
				您的位置：<a :href="homeUrl">首页</a> > <a @click="goSchedules">大会日程</a>
			</div>
			<div class="filter">
				<div class="filter-label" style="line-height: 40px;" :style="{width:enShow?'130px':''}">
					{{enShow?'Query schedule':'查询日程'}}：
				</div>
				<div class="filter-wrap">
					<div class="search" v-if="dateDatas.length">
						<el-input :placeholder="searchText" v-model="searchWord"> </el-input>
						<el-button type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
					</div>
				</div>
			</div>
			<div class="filter">
				<div class="filter-label" :style="{width:enShow?'130px':''}">
					{{enShow?'Select Date':'选择日期'}}：
				</div>
				<div class="filter-wrap">
					<ul class="meetingDate" v-if="dateDatas.length">
						<li v-for="(item, index) in dateDatas" :key="index" :class="{ selected: dateIndex === index }"
							@click="handleMeetingDate(index, item.value)">
							{{ item.name }}
						</li>
					</ul>
				</div>
			</div>
			<div class="filter">
				<div class="filter-label" :style="{width:enShow?'130px':''}">
					{{enShow?'Choose a venue':'选择会场'}}：
				</div>
				<div class="filter-wrap">
					<ul class="meetingDate">
						<li @click="handleMeetingName(0, 0)" :class="{ selected: roomIndex === 0 }">
							{{enShow?'All venues':'全部会场'}}
						</li>
						<li v-for="(item, index) in showAddressDatas" :key="index"
							@click="handleMeetingName(index + 1, item.roomid, item.dateid)"
							:class="{ selected: roomIndex === index + 1 }">
							{{ item.roomname }}
						</li>
					</ul>
				</div>
			</div>
			<div class="schedule_table">
				<template>
					<div class="table_con">
						<div class="meeting-table"
							v-for="(items, indexs) in searchDatas.length ? searchDatas : scheduleDatas" :key="indexs">
							<div class="meeting-prodate">
								{{ items[0].prodate }}
							</div>
							<div class="meeting-roomname">
								{{ items[0].roomname }}
								<p v-if="items[0].roomEnName!=null&&items[0].roomEnName!=''&&enShow">
									{{ items[0].roomEnName }}</p>
							</div>
							<div class="meeting-roomname">
								{{ items[0].ssl_roomtitle }}
								<p v-if="items[0].roomEnTitle!=null&&items[0].roomEnTitle!=''&&enShow">
									{{ items[0].roomEnTitle }}</p>
							</div>
							
							<div class="meeting-first">
								<div class="meeting-1" :class="{ meetingBorder:item.children&&item.children.length>0 }"
									v-for="(item,index) in items" :key="index" v-if="index>0">
									<div class="meeting-2">
										<div class="meeting-title">
											<img src="../../../assets/sj.png">{{item.starttime}}-{{item.endtime}}
											<span v-html="nToBr(item.topic)"></span>
											<span
												v-if="item.entopic!=null&&item.entopic!=''&&enShow"
												v-html="nToBr(item.entopic)"></span>
										</div>
										<div class="meeting-guest">
											<img src="../../../assets/zcr2.png" v-if="item.ssl_identityList">
											<div class="meeting-guest-span"
												v-for="(item1, index1) in item.ssl_identityList" :key="index1">
												<span>{{ item1.rolename }}:</span>
												<div class="guest-list">
													<div v-for="(i, id) in item1.exname" :key="id" class="exname">
														<p @click="handleExname(item1.exid[id])">
															<i v-html="nToBr(i)"></i>
															<span v-html="nToBr(item1.excompany[id])"></span>
														</p>
														<p v-if="enShow" @click="handleExname(item1.exid[id])">
															<i v-html="nToBr(item1.exenname[id])"></i> 
															<span v-html="nToBr(item1.exencompany[id])"></span>
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<template>
										<el-table :data="item.children" style="width: 100%;margin-top: 5px" stripe
											border v-if="item.children&&item.children.length>0">
											<el-table-column label="时间" width="180">
												<template slot-scope="scope">
													<div>{{ scope.row.starttime }}-{{ scope.row.endtime }}</div>
												</template>
											</el-table-column>
											<el-table-column label="主题">
												<template slot-scope="scope">
													<div v-html="nToBr(scope.row.topic)"></div>
													<div v-if="scope.row.entopic!=null&&scope.row.entopic!=''"
														v-html="nToBr(scope.row.entopic)"></div>
												</template>
											</el-table-column>
											<el-table-column label="嘉宾" width="400">
												<template slot-scope="scope">
													<div v-for="(item, index) in scope.row.ssl_identityList"
														:key="index">
														<p>{{ item.rolename }}:</p>
														<div v-for="(i, id) in item.exname" :key="id" class="exname">
															<p @click="handleExname(item.exid[id],'cn')">
																<i v-html="nToBr(i)"></i>
																<span v-html="nToBr(item.excompany[id])"></span>
															</p>
															<p v-if="enShow" @click="handleExname(item.exid[id],'en')">
																<i v-html="nToBr(item.exenname[id])">{{ item.exenname[id] }}</i>
																<span v-html="nToBr(item.exencompany[id])"></span>
															</p>
														</div>
													</div>
												</template>
											</el-table-column>
										</el-table>
									</template>
								</div>
							</div>

							<!-- <el-table
                :data="items"
                border
                style="width: 100%"
                :cell-style="cellStyle"
                :span-method="objectSpanMethod"
                :fit="false"
                row-key="proid"
                default-expand-all
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
              >
                <el-table-column align="center">
                  <template slot-scope="scope">
                    <div :class="{ selectedM: selectedMeeting == indexs }">
                      <div :id="scope.row.id">{{ scope.row.roomname }}</div>
                      <div class="room_tit">
                        <span>{{ scope.row.prodate }}</span>
                        <span>{{ scope.row.ssl_roomtitle }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column width="600px">
                  <template slot-scope="scope">
                    <div>{{ scope.row.starttime }}-{{ scope.row.endtime }}</div>
                  </template>
                </el-table-column>
                <el-table-column align="center">
                  <template slot-scope="scope">
                    <div class="topic_tit">
                      {{ scope.row.topic }}
                    </div>
                    <div v-if="!scope.row.upproid">
                      <div v-for="(item, index) in scope.row.ssl_identityList" :key="index">
                        <span>{{ item.rolename }}</span>
                        :
                        <span
                          v-for="(i, id) in item.exname"
                          :key="id"
                          @click="handleExname(item.exid[id])"
                          class="exname"
                          >{{ i }}</span
                        >
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <div v-if="scope.row.upproid">
                      <div
                        v-for="(item, index) in scope.row.ssl_identityList"
                        :key="index"
                        class="ch_ex"
                      >
                        <span>{{ item.rolename }}</span>
                        :
                        <span
                          v-for="(i, id) in item.exname"
                          :key="id"
                          @click="handleExname(item.exid[id])"
                          class="exname"
                          >{{ i }}</span
                        >
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table> -->
						</div>
						<!-- 嘉宾弹框 -->
						<div>
							<el-dialog :visible.sync="showExList" width="50%" center :close-on-click-modal="false">
								<template>
									<!-- 头像部分 -->
									<div class="details-head">
										<div class="guest-headimg" @click="viewPhoto()">
											<img :src="exPhoto || defaultHeadImg" alt />
										</div>
										<template>
											<div class="guest-intro">
												<div class="guest-name">
													<p v-html="nToBr(excnname)"></p>
													<p v-if="enShow" v-html="nToBr(enname)"></p>
												</div>
												<div class="host">
													<p v-html="nToBr(cncompany)"></p>
													<p v-if="enShow" v-html="nToBr(encompany)"></p>
												</div>
											</div>
										</template>
										<!-- <div class="uploadFile">
                      <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :limit="1"
                        :show-file-list="false"
                        :on-exceed="handleExceed"
                      >
                        <el-button size="small" type="primary">上传课件</el-button>
                      </el-upload>
                    </div> -->
									</div>
									<el-tabs v-model="activeName" @tab-click="handleClick">
										<el-tab-pane :label="enShow?'Profile':'嘉宾简介'" name="0" v-if="introShow">
											<div class="guestIntroduction">
												<p v-if="cnintroduction" v-html="cnintroduction"></p>
												<p v-if="enintroduction&&enShow" v-html="enintroduction"></p>
											</div>
										</el-tab-pane>
										<el-tab-pane :label="enShow?'Task':'嘉宾任务'" name="1"  v-if="isshowprogram==0">
											<template v-if="exDatas.length">
												<div class="ex_details">
													<div class="details-main" v-for="(items, indexs) in exDatas"
														:key="indexs">
														<div class="details-main-head">
															<div class="details-main-head-date">
																<i class=" el-icon-date"></i>
																<span>{{ items[0].proDate }}</span>
															</div>
															<div class="details-list-num">{{ items[0].ProgramCount }}
															</div>
														</div>

														<div class="details-main-con" v-for="(it, id) in items"
															:key="id">
															<!-- <div class="details-texts">
																<i class="el-icon-tickets"></i>
																<div class="details-text">
																	<p v-html="nToBr(it.topic)"></p>
																	<p v-if="enShow" v-html="nToBr(it.entopic)"></p>
																</div>
															</div> -->
															<div class="details-texts">
																<i class="el-icon-time"></i>
																<span v-if="it.startTime">
																	{{ it.startTime }}-{{ it.endTime }}
																</span>
																<span v-html="nToBr(it.topic)"></span>
																<span v-if="enShow" v-html="nToBr(it.entopic)"></span>
															</div>
															<div class="details-texts">
																<i class="el-icon-tickets"></i>
																<div class="details-text">
																	<p>
																		{{ it.roomTitle }}
																	</p>
																</div>
															</div>
															<div class="details-texts">
																<i class="el-icon-location-outline"></i>
																<div class="details-text">
																	<p>
																		{{ it.roomName }}
																	</p>
																	<p v-if="enShow">
																		{{ it.roomEnTitle }} {{ it.roomEnTitle }}
																	</p>
																</div>
															</div>
															<div class="details-texts">
																<i class="el-icon-s-custom"></i>
																<div class="details-text">
																	<p>
												  				{{ it.roleName }}
																	</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</el-tab-pane>
										
									</el-tabs>
								</template>
							</el-dialog>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from "vue-property-decorator";
	import {
		IMeetingInfo,
		current
	} from "@/contants/current.ts";
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode,
	} from "element-china-area-data";

	export default {
		data() {
			return {
				current: {},
				m: '',
				dateIndex: 0, //选中的日期的下标
				roomIndex: 0, //选中的会场的下标
				dateid: 0, //选中的日期id
				roomid: '', //选中的会场id
				scheduleDatas: [], //日程表总数据
				Datas: [], //日程表总数据
				dateDatas: [], //日期数据
				addressDatas: [], // 会场列表数据
				showAddressDatas: [], // 会场列表数据
				selectedMeeting: -1, //根据日期和会场选中的会
				searchWord: '', //搜索的内容
				searchW: '', //搜索的内容
				searchVal: '',
				searchDatas: [],
				issearch: false,
				isLoading: false,
				showExList: false, //是否显示嘉宾弹框
				exDatas: [],
				activeName: "0",
				defaultHeadImg: require("@/assets/images/defaultHeadImg.png"),
				exPhoto: '', //嘉宾头像
				cnintroduction: '', //嘉宾介绍
				excnname: '', //嘉宾姓名
				cncompany: '', //嘉宾公司
				enname: '',
				encompany: '',
				enintroduction: '',
				is_fixed: false, //是否吸顶
				colWidth: 0,
				offsetTop: 0,
				isFixed: false,
				isFun: true,
				fileList: [{
						name: "food.jpeg",
						url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
					},
					{
						name: "food2.jpeg",
						url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
					},
				],
				navShow: true,
				homeUrl: '',
				enShow: true,
				introShow: true,
				searchText: '请输入内容',
				isshowprogram: '',
			}
		},
		created() {
			this.current = new current();
			let _isMobile = this.current.is_Mobile();

			if (_isMobile) {
				let _params = window.location.href.split("?")[1];
				window.location.href = ` https://mp.weiqihd.com/mpweb/#/meeting/place?${_params}`;
			}

			let {
				m
			} = this.$route.query;
			this.m = String(m);
			let parames = {
				m: this.m,
			};
			this.InitMeetingInfo()
			//this.GetAPIProgram(parames);
		},

		mounted() {
			//对整个页面滚轮进行监听，每发生一次滚轮事件，执行一次方法
			window.addEventListener("scroll", this.initHeight);
		},
		methods: {

			/**
			 * 日程模块时，左菜单做吸顶效果
			 */
			initHeight() {
				// 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
				var scrollTop =
					window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				//如果被卷曲的高度大于吸顶元素到顶端位置 的距离
				this.isFixed = scrollTop > this.offsetTop ? true : false;
			},
			//回调中移除监听
			destroyed() {
				window.removeEventListener("scroll", this.initHeight);
			},
			async InitMeetingInfo() {
				let params = {
					m: this.$route.query.m,
				};
				let res = await IMeetingInfo.InitMeetingInfo(params);
				if (res.Code === 1000) {
					this.enShow = res.whetchinen == 0 ? false : true
					this.introShow = res.isshowintrod == 0 ? true : false
					this.isshowprogram = res.isshowprogram
					if (this.enShow) {
						this.searchText = 'Please use name or institution to search for experts'
					} else {
						this.searchText = '请输入内容'
					}
					
					let parames = {
						m: this.m,
					};
					this.GetAPIProgram(parames);
				}
			},
			/**
			 * 获取日程数据（所有会场id和日期id）
			 */
			async GetAPIProgram(parames) {
				let res = await this.$http.schedule.GetAPIProgram(parames);
				if (res.Code === 1000) {
					this.dateDatas = res.childens;
					if( this.enShow ){
						for (let i in this.dateDatas) {
							if (this.dateDatas[i].name == '全部日期') {
								this.dateDatas[i].name = 'All Dates'
							}
							if(this.dateDatas[i].name.indexOf('月')!=-1){
								this.dateDatas[i].name = this.dateDatas[i].name.replace('月','.')
							}
							if(this.dateDatas[i].name.indexOf('日')!=-1){
								this.dateDatas[i].name = this.dateDatas[i].name.replace('日',' ')
							}
						}
					}
					this.getScheduleData(res);
					this.addressDatas = res.RoomDateEntityList;
					if (res.HomeUrl == null || res.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.homeUrl = res.HomeUrl
					}

				}
			},

			/**
			 * 获取所有详细日程数据（DateListEntity）
			 */
			async getScheduleData(data) {
				let {
					childens
				} = data;
				for (let i in childens) {
					let {
						value,
						child
					} = childens[i];
					let dateid = value;
					for (let s in child) {
						let roomid = child[s].value;
						if (dateid != 0 && roomid != 0) {
							let parames = {
								m: this.m,
								dateid,
								roomid,
							};
							await this.GetScheduleDatas(parames);
						}
					}
				}
			},
			/**
			 * 所有详细日程数据（DateListEntity）
			 */
			async GetScheduleDatas(parames) {
				//this.isFun = false
				this.isLoading = true;

				let _res = await this.$http.schedule.GetAPIProgram(parames);
				//console.log(_res)
				if (_res.Code === 1000) {
					//this.isFun = true
					//console.log(this.isFun)
					if (_res.DateListEntity.length) {
						let _list = _res.DateListEntity[0].programListEntity[0].programs.programList;
						//console.log(_res)
						// 将时间戳转时间格式
						for (let i in _list) {
							let {
								starttime,
								endtime,
								upproid,
								expertList,
								programDate
							} = _list[i];
							// _list[i].starttime = this.convertTime(starttime);
							// _list[i].endtime = this.convertTime(endtime);
							_list[i].starttime = starttime;
							_list[i].endtime = endtime;
							// let {
							// 	month,
							// 	day
							// } = this.current.changeFormDate(programDate.prodate);
							// _list[i].programDate.prodate = month + "月" + day + "日";

							if (expertList.length) {
								let _rolenameList = this.filterRolename(expertList);
								_list[i].ssl_identityList = _rolenameList;
							}
						}
						const _data = this.dealData(0, _list);

						console.log('1111',_res.DateListEntity[0])
						_data.unshift({
							roomEnName: _data[0].programRoom.roomenname,
							roomEnTitle: _data[0].programRoom.roomentitle,
							roomname: _data[0].programRoom.roomname,
							ssl_roomtitle: _data[0].programRoom.roomtitle,
							id: "ssl_" + _data[0].proid,
							prodate: _res.DateListEntity[0].proDate,
						});
						//console.log(_data)
						this.Datas.push(_data);
						let {
							dateid,
							roomid
						} = this.$route.query;
						if (dateid) {
							if (this.Datas.length === this.addressDatas.length) {
								for (let i in this.Datas) {
									let items = this.Datas[i];

									if (items[1].dateid == dateid && items[1].roomid == roomid) {
										this.scheduleDatas.push(items);
										break;
									} else if (items[1].dateid == dateid) {
										this.scheduleDatas.push(items);
									}
								}
							}
						} else {
							this.scheduleDatas.push(_data);
						}
					} else {
						console.log(_res);
					}
				}
				this.isLoading = false;
				console.log(this.scheduleDatas)
				// this.scheduleDatas.forEach(item => {
				// 	if (this.enShow) {
				// 		if (item[0].prodate.indexOf('月') != -1) {
				// 			item[0].prodate = item[0].prodate.replace('月', '.')
				// 		}
				// 		if (item[0].prodate.indexOf('日') != -1) {
				// 			item[0].prodate = item[0].prodate.replace('日', ' ')
				// 		}
				// 	}
				// })
			},

			/**
			 * 处理日程同一身份的嘉宾姓名
			 */
			filterRolename(data) {
				let _rolenameList = [], //已去重rolename
					_rolename = []; // 所有rolename
				//去掉重复的身份（rolename）
				for (let i in data) {
					_rolename.push(data[i].exrolemodel.rolename);
					let _indexof = _rolenameList.indexOf(_rolename[i]);
					if (_indexof == -1) {
						_rolenameList.push(data[i].exrolemodel.rolename);
					}
				}
				let _identityList = []; //去重后的身份和姓名总数据
				_rolenameList.forEach((item, index, self) => {
					let _identity = {
						rolename: "",
						exname: [],
						excompany: [],
						exenname: [],
						exencompany: [],
						exid: []
					};
					let _exname = [], //同一身份的嘉宾姓名
						_excompany = [],
						_exenname = [],
						_exencompany = [],
						_exid = [];
					for (let n in data) {
						if (item === data[n].exrolemodel.rolename) {
							_exname.push(data[n].exname);
							_identity.rolename = item;
							_identity.exname = _exname;
							_excompany.push(data[n].excompany);
							_identity.excompany = _excompany;
							_exenname.push(data[n].exenname);
							_identity.exenname = _exenname;
							_exencompany.push(data[n].exencompany);
							_identity.exencompany = _exencompany;
							_exid.push(data[n].exid);
							_identity.exid = _exid;
						}
					}
					_identityList.push(_identity);
				});
				return _identityList;
			},
			/**
			 * 返回09:00式的时间格式
			 */
			convertTime(t) {
				let {
					Hour,
					minute
				} = this.current.changeFormDate(t);
				return Hour + ":" + minute;
			},

			/**
			 *将子日程放入对应的主日程中
			 */
			dealData(firstId, data) {
				//console.log(data)
				let _temp = [];
				for (let i = 0; i < data.length; i++) {
					//console.log(data[i].upproid)
					if (data[i].upproid === firstId) {
						_temp.push(data.splice(i, 1)[0]);
						i--;
					}
				}
				//console.log(_temp)
				for (let i = 0; i < _temp.length; i++) {
					_temp[i].children = this.dealData(_temp[i].proid, data);
				}
				return _temp;
			},
			/**
			 * 选择日期
			 */
			handleMeetingDate(i, dateid) {
				this.scheduleDatas = this.Datas;
				if (i == 0) {
					this.dateIndex = i;
					this.showAddressDatas = [];
					this.issearch = false;
					this.searchDatas = [];
				} else {
					if (this.dateIndex != i) {
						this.dateIndex = i;
						this.dateid = dateid;
						this.roomIndex = 0;
						this.roomid = 0;
						this.selectedMeeting = -1;

						let _addressDatas = [];
						for (let i in this.addressDatas) {
							let item = this.addressDatas[i];
							if (item.dateid == dateid) {
								_addressDatas.push(item);
							}
						}
						this.showAddressDatas = _addressDatas;
						if (this.enShow) {
							console.log(this.showAddressDatas)
							// this.showAddressDatas.forEach(item => {
							// 	if (this.showAddressDatas[i].roomname == '全部会场') {
							// 		this.showAddressDatas[i].roomname = 'All venues'
							// 	}
							// })
						}
						
						let _datas = [];
						for (let s in this.scheduleDatas) {
							let item = this.scheduleDatas[s];

							if (item[1].dateid == dateid) {
								_datas.push(item);
							}
						}
						this.scheduleDatas = _datas;
					} else {
						this.roomIndex = 0;
						this.roomid = 0;
						this.selectedMeeting = -1;

						let _addressDatas = [];
						for (let i in this.addressDatas) {
							let item = this.addressDatas[i];
							if (item.dateid == dateid) {
								_addressDatas.push(item);
							}
						}
						this.showAddressDatas = _addressDatas;
						if (this.enShow) {
							this.showAddressDatas.forEach(item => {
								if (this.showAddressDatas[i].roomname == '全部会场') {
									this.showAddressDatas[i].roomname = 'All venues'
								}
							})
						}
						let _datas = [];
						for (let s in this.scheduleDatas) {
							let item = this.scheduleDatas[s];

							if (item[1].dateid == dateid) {
								_datas.push(item);
							}
						}
						this.scheduleDatas = _datas;
					}
				}
			},
			/**
			 * 选择会场
			 */
			handleMeetingName(index, roomid) {
				this.scheduleDatas = this.Datas;
				if (index == 0) {
					this.roomIndex = index;
					this.handleMeetingDate(this.dateIndex, this.dateid)
				} else if (index != this.roomIndex) {
					this.roomid = roomid;
					this.roomIndex = index;
					let _datas = [];
					for (let j in this.scheduleDatas) {
						let item = this.scheduleDatas[j];
						for (let i in item) {
							if (item[i].dateid == this.dateid && item[i].roomid == this.roomid) {
								//console.log(item)
								_datas.push(item);
								// let _dom = "ssl_" + item[i].proid;
								// let dom = document.getElementById(_dom);
								// if (dom) {
								//   if (j == "0") {
								//     var actualTop = dom.offsetTop;
								//     var current = dom.offsetParent.offsetParent.offsetParent;
								//     if (current !== null) {
								//       actualTop += current.offsetTop;
								//     }
								//     document.documentElement.scrollTop =
								//       actualTop - document.documentElement.clientHeight / 4;
								//   } else {
								//     dom.scrollIntoView({ block: "center" });
								//   }
								//   this.selectedMeeting = j;
								//}
							}
						}
					}
					this.scheduleDatas = [...new Set(_datas)]
					console.log(this.scheduleDatas)
					this.scheduleDatas.forEach(item => {
						if (this.enShow) {
							if (item[0].prodate.indexOf('月') != -1) {
								item[0].prodate = item[0].prodate.replace('月', '.')
							}
							if (item[0].prodate.indexOf('日') != -1) {
								item[0].prodate = item[0].prodate.replace('日', ' ')
							}
						}
					})
				}
			},
			goSchedules() {
				this.dateIndex = 0
				this.roomIndex = 0;
				this.handleMeetingDate(0, 0)
			},
			/**
			 * 合并行或列
			 * data:row, column, rowIndex, columnIndex
			 */
			objectSpanMethod(data) {
				let {
					row,
					column,
					rowIndex,
					columnIndex
				} = data;

				//合并第一列
				if (columnIndex === 0 && rowIndex > 0) {
					return [0, 0];
				}
				//合并主题行
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						return [1, 8];
					} else {
						return [0, 0];
					}
				}
			},
			/**
			 * 改变列的样式
			 */
			cellStyle(data) {
				let {
					row,
					column,
					rowIndex,
					columnIndex
				} = data;

				if (columnIndex === 1) {
					return {
						minWidth: "100px"
					};
				}
				if (columnIndex === 3) {
					return {
						minWidth: "100px"
					};
				}

				//主题样式
				if (rowIndex === 0 && columnIndex === 0) {
					return {
						background: "#eaeaea"
					};
				}
				//主日程项去掉左侧边框
				if (row.upproid === 0 && columnIndex === 2) {
					return {
						borderRight: "none"
					};
				}
			},
			/**
			 * @des 搜索
			 */
			handleSearch() {
				if (this.searchW != this.searchWord) {
					let _datas = [];
					if (this.searchWord) {
						this.searchW = this.searchWord;
						let parames = {
							m: this.m,
							search: this.searchWord,
						};

						this.searchChData(parames);

						this.issearch = true;
					} else {
						this.issearch = false;
						this.searchDatas = [];
					}
				}
			},
			/**
			 * @des 嘉宾个人信息
			 */
			async handleExname(exid) {
				let parames = {
					m: this.m,
					exid,
				};
				let res = await this.$http.schedule.GetAPIExpertProgram(parames);
				let _list = [];
				this.showExList = true;
				let {
					photo,
					cnintroduction,
					cncompany,
					cnname,
					enintroduction,
					enname,
					encmpany
				} = res.expert;
				this.exPhoto = photo;
				console.log(res.expert)

				this.cnintroduction = cnintroduction;
				this.excnname = cnname;
				this.cncompany = cncompany;
				if (cnintroduction) {
					this.cnintroduction = cnintroduction.replace(/\n/g, "<br>");
				}

				this.enname = enname;
				this.encompany = encmpany;
				this.enintroduction = enintroduction;
				if (enintroduction) {
					this.enintroduction = enintroduction.replace(/\n/g, "<br>");
				}


				res.DateListEntity.map((item, index) => {
					let _k = [];
					for (let i in item.programListEntity) {
						let _D = item.programListEntity[i];
						let {
							programList
						} = _D.programs;
						for (let j in programList) {
							let _S = programList[j];
							programList[j] = {
								proDate: item.proDate,
								//时间和日期
								createdTime: this.formatDate(_S.programDate.prodate),
								startTime: _S.starttime,
								endTime: _S.endtime,
								pohto: res.expert.photo, //头像路径
								topic: _S.topic,
								entopic: _S.entopic,
								roomName: _S.programRoom.roomname,
								roomTitle: _S.programRoom.roomtitle,
								roomEnName: _S.programRoom.roomenname,
								roomEnTitle: _S.programRoom.roomentitle,
								roleName: _S.expertList[0].exrolemodel.rolename,
								ProgramCount: item.ProgramCount, //总数量
							};
							_k.push(programList[j]);
						}
					}

					_list.push(_k);
				});

				this.exDatas = _list;
				console.log(this.exDatas)
			},
			formatTime(val) {
				let et = val.split("(");
				let end = et[1].split(")")[0];
				let endtime = Number(end);
				let date = new Date(endtime);
				let h = date.getHours();
				h = h < 10 ? "0" + h : h;
				let m = date.getMinutes();
				m = m < 10 ? "0" + m : m;
				return h + ":" + m;
			},
			formatDate(val) {
				let et = val.split("(");
				let end = et[1].split(")")[0];
				let date = new Date(Number(end));
				let month = date.getMonth() + 1;
				let day = date.getDate();
				return month + "-" + day;
			},
			handleClick(tab, event) {
				// console.log(tab, event);
			},
			/**
			 * 所有详细日程数据（DateListEntity）
			 */
			async searchChData(parames) {
				this.isLoading = true;
				let _d = [],
					_da = [];
				let _res = await this.$http.schedule.GetAPIProgram(parames);

				if (_res.Code === 1000) {
					if (_res.DateListEntity.length) {
						_res.DateListEntity.map((items) => {
							let item = items.programListEntity;
							for (let i in item) {
								let _i = item[i].programs.programList;
								for (let j in _i) {
									let _j = _i[j];
									let {
										starttime,
										endtime,
										upproid,
										expertList,
										programDate
									} = _j;
									let {
										month,
										day
									} = this.current.changeFormDate(programDate.prodate);
									_j.starttime = starttime;
									_j.endtime = endtime;
									_j.programDate.prodate = month + "月" + day + "日";
									_j.ssl_identityList = this.filterRolename(expertList);
									items.programListEntity[i].programs.programList[j] = _j;
								}
								_d = items.programListEntity[i].programs.programList;
								console.log(_d)
								/**_d = this.dealData(0, _i);*/

								if (_d.length > 0) {
									_d.unshift({
										roomname: _d[0].programRoom.roomname,
										ssl_roomtitle: _d[0].programRoom.roomtitle,
										id: "ssl_" + _d[0].proid,
										prodate: _res.DateListEntity[0].proDate,
									});
									_da.push(_d);
								}

							}
						});
						this.searchDatas = _da;
						// this.searchDatas.forEach(item => {
						// 	if (this.enShow) {
						// 		if (item[0].prodate.indexOf('月') != -1) {
						// 			item[0].prodate = item[0].prodate.replace('月', '.')
						// 		}
						// 		if (item[0].prodate.indexOf('日') != -1) {
						// 			item[0].prodate = item[0].prodate.replace('日', ' ')
						// 		}
						// 	}
						// })
					} else {
						this.$message.error({
							message: "未搜索到",
							customClass: "errorMessage"
						});
					}
				}
				this.isLoading = false;
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(
					`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length +
          fileList.length} 个文件`,
				);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			nToBr(str){
				if( str ){
					return str.replace(/\\n/g,'<br/>');
				}else{
					return str
				}
			},
		}
	}
</script>
<style>
	.el-table thead {
		background-color: #4473c2;
		color: #fff;
	}

	.el-table th.el-table__cell.is-leaf,
	.el-table th {
		background-color: #4473c2;
		padding: 5px 0;
	}

	.el-table td,
	.el-table th {
		padding: 5px 0;
	}

	.el-table__body,
	tbody,
	.el-table__row {
		width: auto !important;
	}

	.topic_tit {
		margin-bottom: 10px;
		height: 100%;
		overflow-y: scroll;
	}

	.search {
		button {
			margin-left: 8px;
		}
	}

	.room_tit {
		>span {
			margin-right: 10px;
		}
	}
</style>

<style scoped lang="scss">
	#schedule {
		color: #333;
		font-size: 14px;
		background: #f5f5f5;
		width: 100%;

		.schedule_container {
			width: 100%;
			margin: 0 auto;
			background: #fff;

			.position {
				padding: 0 10px;
				background: #fafafa;
				border-bottom: 1px solid #ddd;
				line-height: 40px;
				border-top: 1px solid #ddd;
				font-size: 14px;
				color: #777;

				a {
					color: #4473c2;
					cursor: pointer;
				}
			}

			.filter {
				padding: 10px 15px 0;
				display: flex;
				font-size: 14px;
				line-height: 30px;

				.filter-label {
					width: 80px;
				}

				.filter-wrap {
					flex: 1;

					.meetingDate {
						display: flex;
						flex: 1;

						>li {
							padding: 0 5px;
							margin-right: 10px;

							&:hover {
								cursor: pointer;
							}
						}
					}
				}
			}

			.table_con {
				padding: 0 15px;
				min-height: 600px;

				.meeting-table {
					margin-bottom: 20px;
				}

				.meeting-prodate {
					text-align: center;
					font-size: 26px;
					color: #4473c2;
					margin-bottom: 8px;
					padding-bottom: 8px;
					border-bottom: 1px solid #ddd;
				}

				.meeting-roomname {
					font-size: 18px;
					font-weight: bold;
					color: #666;
					margin-bottom: 10px;
				}

				.meeting-first {
					width: 100%;
				}

				.meeting-1 {
					padding: 12px 0;
					border-bottom: 1px dotted #ccc;
				}

				.meetingBorder {
					border-bottom: none
				}

				.meeting-2 {}

				.meeting-title {
					font-size: 14px;
					color: #666;
					font-weight: bold;

					img {
						width: 20px;
						height: 20px;
						vertical-align: -4px;
						margin-right: 5px;
					}
				}

				.meeting-guest {
					margin-top: 5px;
					display: flex;

					img {
						width: 20px;
						height: 20px;
						vertical-align: -4px;
						margin-right: 5px;
					}
				}

				.meeting-guest-span {
					flex: 1;
					margin-right: 10px;
					display: flex;

					.guest-list {
						flex: 1;
						margin-left: 10px;
					}
				}

			}

			.schedule_table {
				width: 100%;
				margin: 20px auto;
			}

			.schedule_nav {
				width: 100%;
				height: 57px;
			}

			.schedule_container_nav {
				min-height: 57px;
				background: #fff;
				display: flex;
				justify-content: space-between;
			}
		}

		.selected {
			background: #449bf5 !important;
			color: #fff;
			border-radius: 5px;
		}

		.selectedM {
			color: #278dfa;
		}

		.search {
			width: 450px;
			display: flex;
		}

		.exname {
			margin-right: 6px;
			margin-bottom: 5px;

			&:hover {
				cursor: pointer;
			}

			i {
				color: #278dfa;
				font-weight: bold;
			}
			p{
				display: flex;
				i{
					margin-right: 5px;
					flex: none;
				}
				
			}
		}

		.ch_ex {
			display: flex;
			flex-wrap: wrap;
		}

		.details-head {
			border: 1px solid #dcdfe6;
			display: flex;
			padding: 10px 14px;
			margin-bottom: 15px;
			position: relative;

			.guest-headimg {
				text-align: center;
				margin-right: 10px;
				width: 80px;
				height: 80px;
				border-radius: 100px;

				img {
					width: 100%;
					height: 100%;
					border-radius: 160px;
					object-fit: cover;
				}
			}

			.guest-intro {
				margin: 10px 0;
				font-size: 14px;
				flex: 1;

				.host,
				.guest-name {
					margin-top: 8px;
				}
			}

			.uploadFile {
				position: absolute;
				right: 10px;
				top: 31%;
			}
		}

		.ex_details {
			max-height: 500px;
			overflow: auto;
		}

		.details-texts {
			display: flex;
			align-items: baseline;

			i {
				margin-right: 5px;
			}

			.details-text {
				flex: 1;
			}
		}

		.details-main {
			margin: 2px;
			margin-bottom: 10px;
			box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);

			.details-main-head {
				border-bottom: 1px solid #ccc;
				padding: 8px 0;
				display: flex;
				justify-content: space-between;

				.details-main-head-date {
					color: #0e0ea5;
					padding: 0 0 0 10px;

					>i {
						margin-right: 4px;
					}
				}

				.details-list-num {
					min-width: 20px;
					height: 20px;
					margin-right: 10px;
					background: #00439a;
					border-radius: 6px;
					color: #fff;
					text-align: center;
					line-height: 20px;
				}
			}

			.details-main-con {
				padding: 10px 0;
				border-bottom: 1px solid #ccc;
				margin: 0 10px;

				>div {
					margin: 6px 0;
				}

				&:last-child {
					border: 0;
				}
			}
		}

		.guestIntroduction {
			line-height: 26px;
			min-height: 143px;
			margin: 10px 2px;
			padding: 10px;
			box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
		}

		.roomList {

			.meetingName,
			.meetingDate {
				display: flex;
				line-height: 23px;
				font-size: 14px;
			}

			.meetingName {
				flex-wrap: wrap;

				>li {
					padding: 10px;
					margin: 6px 10px;
					border: 1px solid #ebeef5;
					border-radius: 10px;

					&:hover {
						cursor: pointer;
					}
				}
			}
		}

		.fixed_tit {
			width: 70%;
			background: #fff;
		}

		.personalCenter_content_subheading {
			margin-left: 40px;
			height: 40px;
			display: flex;
			justify-content: space-between;
		}
	}

	.is_fixed {
		position: fixed;
		top: 0;
		z-index: 9;
	}
</style>
